import React from "react";
import { Pie } from "react-chartjs-2";
import { Chart, ArcElement, Tooltip, Legend, SubTitle } from 'chart.js';
Chart.register(ArcElement,
  Tooltip,
  Legend,
  SubTitle);

export function PieChartRetornoMensal({ title, dados }) {


  const footer = (tooltipItems) => {
    return 'Mês: ' + tooltipItems[0].label;
  };

  const label = (context) => {
    let label = context.dataset.label || '';
    if (label) {
      label += ': ';
    }
    if (context.parsed !== null) {
      label += new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(context.parsed);
    }
    return label;
  }

  const data = {
    labels: dados.map(i => i.mes),
    datasets: [
      {
        label: 'Retorno Mensal',
        data: dados.map(i => i.quant),
        backgroundColor: dados.map(i => i.color),
        borderColor: dados.map(i => i.color),
        borderWidth: 1,
      },
    ],
  };

  const options = {
    plugins: {
      title: {
        display: true,
        text: title.toUpperCase(),
        font: {
          size: 16
        }
      },
      subtitle: {
        display: true,
        text: '* Clique nos labels a esquerda para manipular a exibição',
        position: 'bottom',
        padding: '10'
      },
      legend: {
        position: 'left',
      },
      tooltip: {
        callbacks: {
          footer: footer,
          label: label
        },
      }
    },
    responsive: true,
    interaction: {
      mode: 'point',
      intersect: false
    }
  };

  return (
    <div >
      <Pie options={options} data={data} height={150} />
    </div>
  )
}
